module.exports = "<h1>ERROR 404</h1>\n  <h1>Página no encontrada</h1>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/pageerror/pageerror.component.html
// module id = ./src/app/shared/components/pageerror/pageerror.component.html
// module chunks = main